import { Skeleton } from "@/components/ui/skeleton"

export default function VerifyOrderSkeleton() {
  return (
    <div className="flex h-full w-full flex-col">
      <div className="flex h-full w-full flex-col space-y-4 p-4">
        {/* Pickup Section Skeleton */}
        <div className="rounded-lg border p-4 shadow-sm">
          <div className="mb-4 flex items-center justify-between">
            <Skeleton className="h-7 w-16" /> {/* "Pickup" title */}
            <div className="flex gap-2">
              <Skeleton className="h-6 w-6 rounded" /> {/* Edit icon */}
              <Skeleton className="h-6 w-6 rounded" /> {/* Delete icon */}
            </div>
          </div>

          <div className="space-y-3">
            <Skeleton className="h-6 w-80" /> {/* Company name */}
            <Skeleton className="h-5 w-72" /> {/* Address */}
            <Skeleton className="h-5 w-64" /> {/* Reference number */}
            <Skeleton className="h-5 w-48" /> {/* Pickup date */}
          </div>
        </div>

        {/* First Delivery Section Skeleton */}
        <div className="rounded-lg border p-4 shadow-sm">
          <div className="mb-4 flex items-center justify-between">
            <Skeleton className="h-7 w-20" /> {/* "Delivery" title */}
            <div className="flex gap-2">
              <Skeleton className="h-6 w-6 rounded" /> {/* Edit icon */}
              <Skeleton className="h-6 w-6 rounded" /> {/* Delete icon */}
            </div>
          </div>

          <div className="space-y-3">
            <Skeleton className="h-6 w-72" /> {/* Company name */}
            <Skeleton className="h-5 w-80" /> {/* Address */}
            <Skeleton className="h-5 w-56" /> {/* Reference number */}
            <Skeleton className="h-5 w-52" /> {/* Delivery date */}
          </div>
        </div>

        {/* Second Delivery Section Skeleton */}
        <div className="rounded-lg border p-4 shadow-sm">
          <div className="mb-4 flex items-center justify-between">
            <Skeleton className="h-7 w-20" /> {/* "Delivery" title */}
            <div className="flex gap-2">
              <Skeleton className="h-6 w-6 rounded" /> {/* Edit icon */}
              <Skeleton className="h-6 w-6 rounded" /> {/* Delete icon */}
            </div>
          </div>

          <div className="space-y-3">
            <Skeleton className="w-76 h-6" /> {/* Company name */}
            <Skeleton className="w-68 h-5" /> {/* Address */}
            <Skeleton className="h-5 w-56" /> {/* Reference number */}
            <Skeleton className="h-5 w-52" /> {/* Delivery date */}
          </div>
        </div>

        {/* Add New Stop Button Skeleton */}
        <div className="flex justify-end py-4">
          <Skeleton className="h-10 w-40 rounded-lg" />
          {/* Add New Stop button */}
        </div>

        {/* Order Details Section Skeleton */}
        <div className="rounded-lg border p-4 shadow-sm">
          <div className="space-y-3">
            <Skeleton className="h-7 w-32" /> {/* "Order Details" title */}
            <div className="space-y-2">
              <Skeleton className="h-5 w-40" /> {/* "Order number:" label */}
              <Skeleton className="h-6 w-28" /> {/* Order number value */}
            </div>
          </div>
        </div>

        {/* Continue Button Skeleton */}
        <div className="flex justify-end py-4">
          <Skeleton className="h-10 w-40 rounded-lg" />
        </div>
      </div>
    </div>
  )
}
